<template>
  <a-modal v-model="visible" width="70%" :title="`${form.id ? $t('编辑应用') : $t('新增应用')}`" destroyOnClose>
    <div slot="footer">
      <a-button type="default" @click="() => visible = false">{{ $t('取消') }}</a-button>
      <a-button type="primary" :loading="loading" @click="handleCommit">{{ $t('保存') }}</a-button>
    </div>
    <a-form-model ref="form" :model="form" :rules="rules" :labelCol="{ span: 3 }" :wrapperCol="{ span: 18 }">
      <a-card :bordered="false" :title="$t('密钥信息')">
        <a-form-model-item :label="$t('应用ID')" prop="appId" v-if="form.appId">
          <a-input v-model="form.appId" disabled />
        </a-form-model-item>
        <a-form-model-item :label="$t('应用密钥')" prop="appSecret">
          <a-input v-model="form.appSecret" />
        </a-form-model-item>
      </a-card>
      <a-card :bordered="false" :title="$t('基础信息')">
        <a-form-model-item :label="$t('应用名称')" prop="name">
          <a-input v-model="form.name" />
        </a-form-model-item>
        <a-form-model-item :label="$t('应用描述')" prop="remark">
          <a-textarea v-model="form.remark" />
        </a-form-model-item>
        <a-form-model-item :label="$t('应用图标')" prop="logo">
          <a-upload accept="image/*" :customRequest="handleUploadLogo" listType="picture-card" :fileList="logoList" @change="handleLogoChange" @preview="handleLogoPreview">
            <a-button type="primary" v-if="logoList.length == 0">{{ $t('选择图标') }}</a-button>
          </a-upload>
        </a-form-model-item>
      </a-card>
      <a-card :bordered="false" :title="$t('布局信息')">
        <a-form-model-item :label="$t('应用布局')" prop="banner">
          <a-radio-group v-model="form.banner" :options="AppBannerOptions" />
        </a-form-model-item>
        <a-form-model-item :label="$t('主题')" prop="theme">
          <a-radio-group v-model="form.theme" :options="AppThemeOptions" />
        </a-form-model-item>
      </a-card>
    </a-form-model>
    <a-modal v-model="previewVisible" :footer="null">
      <img style="width: 100%" :src="logoUrl" />
    </a-modal>
  </a-modal>
</template>
<script>
import { saveApp } from '@/api/app/app'
import { uploadFile, getDownloadUrl } from '@/api/file/file'
import { AppBannerOptions, AppThemeOptions } from '@/constants/AppConstants'

export default {
  data() {
    return {
      AppBannerOptions,
      AppThemeOptions,
      visible: false,
      loading: false,
      previewVisible: false,
      form: {},
      logoList: [],
    }
  },
  computed: {
    logoUrl() {
      const logoList = this.logoList.filter(e => e.status === 'done')
      if (logoList.length === 0) {
        return null
      }
      const logo = logoList[0]
      const fileId = logo.response.id
      return getDownloadUrl(fileId)
    },
    rules() {
      return {
        name: [
          { required: true, message: this.$t('请输入') }
        ]
      }
    }
  },
  methods: {
    show(data) {
      this.form = { ...data }
      this.logoList = this.form.logo ? [{
        uid: this.form.logo,
        name: 'logo',
        status: 'done',
        response: { id: this.form.logo },
        url: getDownloadUrl(this.form.logo)
      }] : []
      this.visible = true
    },
    handleUploadLogo(file) {
      file.onProgress()
      uploadFile(file.file).then(res => {
        if (res.code === 0) {
          file.onSuccess(res.data)
          this.form.logo = res.data.id
        } else {
          file.onError(res.message)
          this.$message.error(res.message)
        }
      }).catch(e => {
        file.onError(e)
      })
    },
    handleLogoChange(data) {
      const fileList = data.fileList
      fileList.forEach(f => {
        if (f.status === 'done') {
          f.url = getDownloadUrl(f.response.id)
        }
      })
      this.logoList = fileList
    },
    handleLogoPreview() {
      this.previewVisible = true
    },
    handleCommit() {
      this.$refs.form.validate((success, fields) => {
        if (!success) {
          return
        }
        this.loading = true
        const commitData = { ...this.form }
        saveApp(commitData).then(res => {
          if (res.code === 0) {
            this.$emit('ok')
            this.$message.success(this.$t('保存成功'))
            this.visible = false
          } else {
            this.$message.error(res.message || this.$t('保存失败'))
          }
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>